// Import necessary modules from React and other libraries
import React, { Fragment, useState, useEffect } from "react";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { Row, Col, Card, CardHeader, CardBody } from "reactstrap";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { format, parseISO } from 'date-fns';

// Import custom components and styles
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../../components/Loaders/DnaLoader";
import "../../../assets/custom css/loadoverlay.scss";
import moment from 'moment';

import Alerts from "../../../components/Alerts/alerts";

import DataTable from 'react-data-table-component';
import DashboardService from "../dashboard.service";
import AuthService from "../../Authentication/auth.service";
import Header from './Header';
import CategorySection from './CategorySection';
import FeaturedProducts from './FeaturedProducts';

const Home = () => {
  const [branch, setBranch] = useState('');
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  console.log("branch", branch)
  useEffect(() => {
    if (branch !== '')
      fetchCategories(0, pageLimit)
  }, [branch]);

  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const [Data, setData] = useState([]);

  // Perform actions on component mount or when 'pageLimit' changes
  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
    // fetchCategories(0, pageLimit)
  }, [pageLimit]);

  // Function to fetch table data based on page index and limit
  function fetchCategories(page_index, page_limit) {
    // Prepare filter and retrieve user data from local storage
    var filter = {};
    // const userString = localStorage.getItem('user');
    // const user = JSON.parse(userString);
    // const userId = user['_id'];
    // filter["customer_id"] = userId

    var offset = (page_index - 1) * page_limit;
    if (offset < 1) {
      offset = 0;
    }
    setLoading(true);
    let branches = [];
    branches.push(branch)
    DashboardService.getAllCategories(offset, page_limit, branches).then((response) => {
      setLoading(false); // Set loading state to false after data retrieval
      // Handle response data
      if (response.data.message === "Unauthorized") {
        // Perform logout and redirection for unauthorized access
        AuthService.logout();
        navigate("/login");
        window.location.reload();
      }
      else {
        setData(response.data); // Set retrieved data to state variable 'Data'
        if (response.data.data) {
          console.log("ALL Category", response.data.data);
          setCategories(response.data.data);
          if (response.data.data.length > 0) {
            setSelectedCategory(response.data.data[0]._id);
          }
          // setBranches(response.data.data); // Set total rows based on response length
        }
      }
    },
      // Handle error scenarios
      (error) => {
        setLoading(false); // Set loading state to false in case of error
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        console.log("Net:-", errContent)
        if (errContent) {
          Alerts.swalErrorAlert(errContent)
        }
        else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."))
        }
      })
  };


  return (
    <Fragment>
      <div className="app-main__outer">
        <div className="app-main__inner">
          <TransitionGroup>
            <CSSTransition component="div" classNames="TabsAnimation"
              appear={true} timeout={0} enter={false} exit={false}>
              <div>
                <div className="app-page-title">
                  <div className="page-title-wrapper">
                    <Header branch={branch} setBranch={setBranch} />
                  </div>
                </div>
                <div>
                  <container>
                    <CategorySection
                      categories={categories}
                      selectedCategory={selectedCategory}
                      setSelectedCategory={setSelectedCategory}
                    />
                    <FeaturedProducts selectedCategory={selectedCategory} selectedBranch={branch} />
                  </container>
                </div>
              </div>
            </CSSTransition>
          </TransitionGroup>
        </div>
      </div>
    </Fragment>
  );
};

export default Home;